import React from "react";

const AboutSection = () => {
  return (
    <div className="overflow-hidden space" id="about-sec">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Image Section */}
          <div className="col-xl-6">
            <div className="img-box15">
              <div className="img1">
                <img src="/assets/image/IMG-20250429-WA0001.jpg" alt="About" />
              </div>

              <div className="about-shape-1"></div>

              <div className="img2 th-anim">
                <img src="/assets/image/IMG-20250429-WA0011.jpg" alt="About" />
              </div>

              <div className="th-experience pulse-anim">
                <div className="th-experience_content">
                  <h2 className="experience-year">
                    <span className="counter-number">1.5</span>k
                  </h2>
                  <p
                    className="experience-text fw-bold"
                    style={{ fontSize: "10px" }}
                  >
                    Customers Satisfied
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Content Section */}
          <div className="col-xl-6">
            <div className="title-area mb-20 pe-xl-5 me-xl-5">
              <span className="sub-title6">
                ABOUT US
                <span className="shape right">
                  <span className="dots"></span>
                </span>
              </span>
              <h2 className="sec-title mb-20">
                We Don’t Just Clean — We Protect What Matters Most
              </h2>
            </div>
            <p className="sec-text mb-30">
              At Al Jurf Pest Control LLC, we go beyond cleaning — we safeguard
              your home and workspaces from pests and ensure a healthier, safer
              environment. With a strong commitment to quality, innovation, and
              eco-conscious solutions, we provide professional cleaning and pest
              control services customized for homes, offices, and commercial
              properties across Dubai.
            </p>

            <div className="checklist style11 mt-2">
              <ul>
                <li>Trained & Experienced Pest Control Technicians</li>
                <li>Eco-Friendly & Safe Treatment Solutions</li>
                <li>Customized Pest Management Plans</li>
                <li>Discreet Service with Full Privacy Assurance</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
